/**
 * This methods returns complete url after appending prefix
 * It also fixes hash string if present at incorrect location
 * @param {string} href - url from the service in which prefix is appended and hash is fixed
 * @param {string} prefix - extra query params need to be appended to href
 * ex. "http://test.com#hashStr?q1=1&q2=2" will be transformed to "http://test.com?q1=1&q2=2#hashStr"
 * @returns {string}
 */
export default function fixHref(href , prefix) {
	if (~href.indexOf('?')) {
        href += '&'+prefix;
    } else {
        href += '?'+prefix;
    }
	var hashIndex = href.indexOf("#");
	var questionMarkIndex = href.indexOf("?");
	if( hashIndex > 0 && questionMarkIndex != -1 && hashIndex < questionMarkIndex) {
		var hashStr = href.substr(hashIndex , questionMarkIndex-hashIndex);
		href = href.replace(hashStr, "");
		href = href + hashStr;
	}
	return href;
}